<template>
  <div class="container">
    <div class="contents">
      <div class="about">
        <div class="about-title">
          <h2>Work<span>実績</span></h2>
        </div>
      </div>

      <div class="item-title font-20">
        Graphic Design
      </div>

      <div class="product-list">
        <div class="product-item" v-for="listItem in listItems" :key="listItem.id">     
          <div class="product-image">
            <router-link :to="`/product/${ listItem.id }`">
              <img :src="listItem.image">
            </router-link>
          </div>
          <div class="product-text">
            <div class="product-name">
              <router-link :to="`/product/${ listItem.id }`">{{ listItem.name }}</router-link>
            </div>
            <div class="product-content">{{ listItem.content }}</div>
          </div>
        </div>
      </div>
      <a
        href="javascript:void(0)"
        class="list-item-button"
        v-if="(listItems.length - count) >= 0"
        type="button"
        @click="isMore"
      >
          More View
      </a>

      <!-- <div class="download">
        <div class="download-button"><a href="javascript:void(0)" @click="copyToClipboard">Download</a></div>
      </div>
      <input type="text" id="copy-target" class="clip-copy" value="git clone https://d-mori-570415@bitbucket.org/d-mori-570415/webdesigntemplate.git" readonly> -->
    </div>
  </div>
</template>

<script>
import products from '@/api/products.js'

export default {
  head: {
    meta: [
      { name: 'description', content: 'これは個人ポートフォリオサイトです。Vue.jsを使って作ってします。' },
      { property: 'og:title', content: 'ポートフォリオ一覧ページ' },
      { property: 'og:description', content: 'これは個人ポートフォリオサイトです。Vue.jsを使って作ってします。' },
      { property: 'og:type', content: 'article' },
      { property: 'og:url', content: 'https://example.com' },
      { property: 'og:image', content: 'https://example.com/img/og.png' },
      { name: 'twitter:card', content: 'summary' }
    ]
  },
  data () {
    return {
      count: 10
    }
  },
  computed: {
    listItems() {
        const list = products.fetch()
        return list.slice(0, this.count)
    }
  },
  methods: {
    isMore() {
        this.count += 10
    },
    copyToClipboard() {
      let copyTarget = document.getElementById('copy-target')
      copyTarget.select()
      document.execCommand('Copy')
      alert('コマンドラインもしくはターミナルにペーストして実行してください')
    }
  },
}
</script>

<style scoped>
  h1 {
    margin: 0 0 40px 0;
  }
  h2 span {
    margin: 0 0 30px 0;
    letter-spacing: -1px;
  }
  .container {
    width: 75%;
  }
  .contents .about .about-title {
    margin: 0 0 50px 0;
  }
  .contents .about .about-title span {
    display: block;
    font-size: 12px;
  }
  .contents .item-title {
    text-align: center;
    width: 150px;
    margin: 0 auto 30px;
    text-decoration: underline;
  }
  .product-list {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
  .product-list .product-item {
    width: 250px;
    margin: 0 20px 40px;
  }
  .product-list .product-item .product-image img {
    width: 100%;
    margin: 0 0 10px 0;
    object-fit: cover;
    vertical-align: bottom;
    transition: .5s;
    filter: drop-shadow(0 0 2px rgba(0,0,0,.3));
  }
  .product-list .product-item .product-image img:hover {
    opacity: .5;
  }
  .product-list .product-item .product-text .product-name {
    text-align: left;
    font-size: 12px;
    transition: .5s;
  }
  .product-list .product-item .product-text .product-name:hover {
    opacity: .5;
  }
  .product-list .product-item .product-text .product-content {
    font-size: 13px;
    line-height: 20px;
    text-align: justify;
  }
  .list-item-button {
    display: block;
    color: #000;
    width: 200px;
    margin: 0 auto;
    padding: 10px 0;
    border: 1px solid #000;
    transition: .5s;
  }
  .list-item-button:hover {
    color: #fff;
    background: #000;
  }
@media screen and (max-width:768px) {
  .container {
    width: 90%;
  }
  .product-list .product-item {
    width: 100%;
    margin: 0 auto 40px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ProductList.vue